import React from 'react';

import { PrismicRichText } from '@prismicio/react';

import * as S from './styles';
import { IProps } from './types';

export const ContactsAddress: React.FC<IProps> = ({ contacts }) => (
  <S.Wrapper>
    <S.Title>
      <S.H3>{contacts?.address_title}</S.H3>
    </S.Title>
    <S.Address>
      <S.Item>
        <PrismicRichText field={contacts?.address} />
      </S.Item>
    </S.Address>
    <S.Details>
      <S.Item>
        <PrismicRichText field={contacts?.registration_details} />
      </S.Item>
    </S.Details>
  </S.Wrapper>
);
